module.exports = __webpack_public_path__ + "img/shenqing.bedf279d.png";